
import * as x from '../helpers/xmlHelpers';


export class StructureAnalysisDetail {
    constructor(doc)
    {
		this.label = null;
		this.effectiveAgeDescription = null;
		this.effectiveAgeRangeHighYearsCount = null;
		this.effectiveAgeRangeLowYearsCount = null;
		this.effectiveAgeYearsCount = null;
		this.estimatedRemainingEconomicLifeDescription = null;
		this.estimatedRemainingEconomicLifeYearsCount = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.effectiveAgeDescription = x.getStringElement(doc, "./ns:EffectiveAgeDescription");
		this.effectiveAgeRangeHighYearsCount = x.getIntegerElement(doc, "./ns:EffectiveAgeRangeHighYearsCount");
		this.effectiveAgeRangeLowYearsCount = x.getIntegerElement(doc, "./ns:EffectiveAgeRangeLowYearsCount");
		this.effectiveAgeYearsCount = x.getIntegerElement(doc, "./ns:EffectiveAgeYearsCount");
		this.estimatedRemainingEconomicLifeDescription = x.getStringElement(doc, "./ns:EstimatedRemainingEconomicLifeDescription");
		this.estimatedRemainingEconomicLifeYearsCount = x.getIntegerElement(doc, "./ns:EstimatedRemainingEconomicLifeYearsCount");
   }
}

export class StructureAnalysis {
    constructor(doc)
    {
		this.label = null;
		this.structureAnalysisDetail = null;
		var node;

		this.label = x.getStringAttribute(doc,"xlink:label");
		node = x.selectSingleNode(doc, "./ns:STRUCTURE_ANALYSIS_DETAIL");
		if (node !== null)
				this.structureAnalysisDetail = new StructureAnalysisDetail(node);
   }
}


// end
